"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
import fetch from "../util/fetch";
export default {
  _update: function(method, params) {
    return ApiService.addErrorHandler(fetch("/api/settings/" + method, {
      method: "POST",
      data: params
    }).then(
      DataStoreService.responseHandler,
      _.identity
    ));
  },
  setDocumentTypes: function(types) {
    return this._update("document_types", { types });
  },
  setCustomerVisibleDocumentTypes: function(types) {
    return this._update(
      "document_types",
      { customer_visible_document_types: types }
    );
  },
  setRequiredReceivablesDocumentTypes: function(types) {
    return this._update(
      "document_types",
      { required_receivables_types: types }
    );
  }
};
